<template>
  <v-select v-bind="$attrs" v-on="$listeners" :items="items" item-text="codeValue" item-value="code" :menu-props="{ offsetY: true }" :multiple="multi"/>
</template>

<script>
import Request from "@/commons/request";
export default {
  name: "WtkSelect",
  inheritAttrs: false,
  props: {
    //数据库字段名字(DISABLE_TYPE) 或 静态的字段（0:否/1:是）
    list: {
      type: String,
      default: null,
    },
    multi: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.list.includes(":") ? this.statc() : this.miscs();
  },
  methods: {
    miscs() {
      Request.getForm(`dict/misc/list/${this.list}`).then((res) => {
        this.items = res.data;
      });
    },
    statc() {
      this.list.split("/").forEach((it) => {
        var its = it.split(":");
        this.items.push({ code: its[0], codeValue: its[1] });
      });
    },
  },
};
</script>

<style>
</style>